/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetAddress",
                type: "address",
            },
        ],
        name: "authorize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "authorized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balances",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "strategyIndex",
                type: "uint256",
            },
            {
                internalType: "uint128[]",
                name: "commissionList",
                type: "uint128[]",
            },
        ],
        name: "changeCommission",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "payer",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "chargeFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "strategyIndex",
                type: "uint256",
            },
        ],
        name: "commission",
        outputs: [
            {
                internalType: "uint128[]",
                name: "commissionList",
                type: "uint128[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "weth9",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferToken2Pool",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetAddress",
                type: "address",
            },
        ],
        name: "unauthorize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "unwrapWETH",
                type: "bool",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class Bank__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Bank__factory.bytecode = _bytecode;
Bank__factory.abi = _abi;
